module.exports = __webpack_public_path__ + "img/haft-poznan-15.8a05fbbc.jpg";